import { AsyncResult } from '../utils/asyncresult';

export class CustomXmlPart {
  private _customXmlPart: Office.CustomXmlPart;

  constructor(cxp: Office.CustomXmlPart) {
    this._customXmlPart = cxp;
  }

  get id(): string {
    return this._customXmlPart.id;
  }

  async getXml(): Promise<string> {
    const rootNode = await this.getRootNode();
    return await this.getNodeXml(rootNode);
  }

  async setXml(xml: string): Promise<void> {
    const rootNode = await this.getRootNode();
    return await this.setNodeXml(rootNode, xml);
  }

  private getRootNode(): Promise<Office.CustomXmlNode> {
    return new Promise((resolve, reject) => {
      this._customXmlPart.getNodesAsync('/*', (result) => {
        if (AsyncResult.succeeded(result) && result.value.length === 1) {
          resolve(result.value[0]);
        } else {
          reject(result.error);
        }
      });
    });
  }

  private getNodeXml(node: Office.CustomXmlNode): Promise<string> {
    return new Promise((resolve, reject) => {
      node.getXmlAsync((result) => {
        if (AsyncResult.succeeded(result)) {
          resolve(result.value);
        } else {
          reject(result.error);
        }
      });
    });
  }

  private setNodeXml(node: Office.CustomXmlNode, xml: string): Promise<void> {
    return new Promise((resolve, reject) => {
      node.setXmlAsync(xml, (result) => {
        if (AsyncResult.succeeded(result)) {
          resolve(result.value);
        } else {
          reject(result.error);
        }
      });
    });
  }
}

// class ModelPart {
//   constructor(private _customXmlPart: CustomXmlPart) {
//   }
//
//   async add(namespace: string, entity: EntityTypeLabelPair, field: FieldContext): Promise<void> {
//
//   }
//
//   private async addField(namespace: string, entity: EntityTypeLabelPair, field: FieldContext): Promise<void> {
//     const xml = await this._customXmlPart.getXml();
//     const dom = new Dom(xml);
//     const path = [namespace, entity.entity, ...field.field.path.split('.')];
//     const fieldElement = dom.ensurePath(path);
//     fieldElement.setAttribute('th:text', `\${${path.join('.')}}`);
//     fieldElement.textContent = this.createSampleText([entity.label, field.field.label]);
//     console.log('Model part XML', dom.outerHTML);
//     await this._customXmlPart.setXml(dom.outerHTML);
//   }
//
//   private createSampleText(parts: string[]): string {
//     return `|${parts.join('-')}|`;
//   }
// }
